module.exports = __webpack_public_path__ + "static/media/productos_ingredientes_pasta_cacahuate.2f7b6e9e.jpg";